import { DocumentType } from '../../batches';
import { BlankStatusType } from '../blanks.metadata';

export class Blank {
  public id: number;
  public list_id: number;
  public status: BlankStatusType;
  public path: string;
  public expire_at: string;
  public created_at: string;
  public updated_at: string;
  public selected?: boolean;
  public disabled?: boolean;

  constructor(data: Blank) {
    if (data.status === 'error') {
      data.disabled = true;
    }
    Object.assign(this, data);
  }
}
